import {Injectable, TemplateRef} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {ComponentType} from '@angular/cdk/portal';
import {ButtonProperty} from '../models/button.model';
import {ConfirmDialogComponent} from 'src/app/layout/dialogs/confirm-dialog/confirm-dialog.component';
import {Observable} from 'rxjs';
import {dialogDefaultConfig} from 'src/app/config/dialog.config';
import { InfoDialogComponent } from 'src/app/layout/dialogs/info-dialog/info-dialog.component';
import { ScreenService } from './screen.service';
import { ErrorDialogComponent } from 'src/app/layout/dialogs/error-dialog/error-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
    public dialog: MatDialog,
    private screen: ScreenService
  ) {}

  open<T, D = any, R = any>(template: ComponentType<T> | TemplateRef<T>, config?: MatDialogConfig<D>, setWidth?:string): MatDialogRef<T, R> {
    config = { ...config, ...{ width: this.screen.lowerThen('sm') ? '100%' : '80%', maxWidth: setWidth ? setWidth : this.screen.lowerThen('sm') ? '100%' : '500px' }};
    return this.dialog.open(template, {...dialogDefaultConfig, ...config})
  }

  confirm(title: string, message: string, acceptButton?: ButtonProperty, rejectButton?: ButtonProperty): Observable<any> {
    const dialogRef = this.open(ConfirmDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;
    if (acceptButton) {
      dialogRef.componentInstance.acceptButton = acceptButton;
    }
    if (rejectButton) {
      dialogRef.componentInstance.rejectButton = rejectButton;
    }
    return dialogRef.afterClosed()
  }

  message(type: 'success' | 'info' | 'warning' | 'error', title: string, message: string, autoClose?: boolean,  autoCloseTime?: number, acceptButton?: ButtonProperty) {
    const dialogRef = this.open(InfoDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.type = type;
    if (autoClose) {
      dialogRef.componentInstance.setAutoClose(autoCloseTime);
    }

    if (acceptButton) {
      dialogRef.componentInstance.acceptButton = acceptButton;
    }
    return dialogRef.afterClosed()
  }

  success(message: string, autoClose?: boolean, autoCloseTime?: number, title?: string, acceptButton?: ButtonProperty) {
    return this.message('success', title ?? 'Tutto ok!', message, autoClose, autoCloseTime, acceptButton);
  }

  info(message: string, autoClose?: boolean, autoCloseTime?: number, title?: string, acceptButton?: ButtonProperty) {
    return this.message('info', title ?? 'Info', message, autoClose, autoCloseTime, acceptButton);
  }

  warning(message: string, autoClose?: boolean, autoCloseTime?: number, title?: string, acceptButton?: ButtonProperty) {
    return this.message('warning', title ?? 'Attenzione!', message, autoClose, autoCloseTime, acceptButton);
  }

  error(message: string, autoClose?: boolean, autoCloseTime?: number, title?: string, acceptButton?: ButtonProperty) {
    
    return this.message('error', title ?? 'Ooops!', message, autoClose, autoCloseTime, acceptButton);
  }

  errorDownloadContent(message: string, autoClose?: boolean, autoCloseTime?: number, title?: string, acceptButton?: ButtonProperty, downloadButton?: ButtonProperty){

    return this.messageDownload('error', title ?? 'Ooops!', message, autoClose, autoCloseTime, acceptButton, downloadButton);
  }

  messageDownload(type: 'success' | 'info' | 'warning' | 'error', title: string, message: string, autoClose?: boolean,  autoCloseTime?: number, acceptButton?: ButtonProperty,  downloadButton?: ButtonProperty) {
    const dialogRef = this.open(ErrorDialogComponent);
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.type = type;
    if (autoClose) {
      dialogRef.componentInstance.setAutoClose(autoCloseTime);
    }

    if (acceptButton) {
      dialogRef.componentInstance.acceptButton = acceptButton;
    }
    if (downloadButton) {
      dialogRef.componentInstance.downloadButton = downloadButton;
    }
    return dialogRef.afterClosed()
  }

  
}
